import axios from 'axios'

var qs = require('qs');
var root = window.API_ROOT

//保存某一行的数据
export const saveData = (params, flag) => {
  if (!flag) {//修改
    return axios.post(root + '/set/user/update', qs.stringify(params))
  } else {
    return axios.post(root + '/set/user/save', qs.stringify(params));
  }
}

/**
 * 获取数据组
 * @param params
 * @returns {AxiosPromise<any>}
 */
export const getTableDate = (params) => {
  return axios.post(root + '/set/user/getTableDate', qs.stringify(params));
}

/**
 * 删除选中的数据
 * @param params
 */
export const deleteData = (params) => {
  return axios.post(root + '/set/user/remove', qs.stringify(params))
}

/**
 * 根据uguid获取岗位的一条详细信息
 * @param params
 * @returns {AxiosPromise<any>}
 */
export const getPostDetaile = (params) => {
  return axios.post(root + '/set/user/getUserDetaile', qs.stringify(params))
}

//获取岗位树
export const getUsersTree = (params) => {
  return axios.post(root + '/set/user/tree', qs.stringify(params))
}

//获取所有子部门
export const getSonDept = (params) => {
  return axios.post(root + '/set/dept/getSonDept', qs.stringify(params))
}

//岗位权限
export const listRoles = () => {
  return axios.get(root + '/set/user/listRoles')
}


export const listHasDept = () => {
  return axios.get(root + '/set/user/listHasDept')
}

export const updateRights = (params) => {
  return axios.post(root + '/set/user/updateRights', qs.stringify(params))
}




// WEBPACK FOOTER //
// ./src/api/set/post.js